(function() {
	'use strict';
	angular.module('app.core')
		.service('globalItemFilterFunctionsService', globalItemFilterFunctionsService);

	globalItemFilterFunctionsService.$inject = ['$timeout', '$filter'];
	function globalItemFilterFunctionsService($timeout, $filter) {
		var filterList = _.toArray(globalConfig.user.authFacts)
			.filter(function(factory) {
				return (factory.roleType !== 'Supplier') && factory.customerNdx === globalConfig.customer.id;
			})
			.map(function (factory) {
				return {
					id: factory.ndx,
					selected: true,
					name: factory.alias || factory.name
				};
			})
			.sort(function (a, b) {
				if (a.id === globalConfig.factory.id)
					return -1;
				if (b.id === globalConfig.factory.id)
					return 1;
				if (a.name < b.name)
					return -1;
				if (a.name > b.name)
					return  1;
				return 0;
			});
		var tempFilterList = filterList.map(function (factory) {
			return Object.assign({}, factory);
		});
		var viewValues = {
			numberSelected: tempFilterList.length,
			allSelected: true,
			noneSelected: false,
			allVisibleSelected: false,
			noneVisibleSelected: false,
			visibleMenu: '',
			filterButtonText: 'All Sites',
			isOpen: false
		};


		return {
			setOpen: setOpen,
			filterList: filterList,
			getFactoryList: getFactoryList,
			tempFilterList: tempFilterList,
			getViewValues: getViewValues,
			getFactoryListString: getFactoryListString,
			toggleAll: toggleAll,
			applySelection: applySelection,
			cancelSelection: cancelSelection,
			toggleItem: toggleItem,
			getFilteredModel: getFilteredModel,
			updateVisibleAllOrNone: updateVisibleAllOrNone,
			isReadOnly: isReadOnly,
			excludeSharedFilterText: true
		};

		function getFactoryList() {
			return filterList
				.filter(function (factory) {
					return factory.selected;
				})
				.map(function (factory) {
					return factory.id;
				})
				.join(',');
		}

		function setOpen (isOpen) {
			viewValues.isOpen = isOpen;
			if (isOpen) viewValues.visibleMenu = 'site';
			if (!isOpen) viewValues.visibleMenu = '';
		}

		function getFactoryListString(maxLen, searchResultsFactories) {
			var factoryNames = filterList
				.filter(function (factory) {
					return searchResultsFactories ? searchResultsFactories.indexOf('' + factory.id) > -1 : factory.selected;
				})
				.map(function (factory) {
					return factory.name;
				});
			if (searchResultsFactories === 'LDNA_A_S'
					|| factoryNames.length === 0
					|| factoryNames.length === filterList.length
			) {
				return searchResultsFactories ? 'all sites' : 'All Sites';
			} else if (factoryNames.length === 1) {
				return factoryNames[0];
			} else if (factoryNames.length === 2) {
				return factoryNames.join(' and ');
			} else if (factoryNames.length <= maxLen) {
				return factoryNames.slice(0, factoryNames.length - 1).join(', ') + ', and ' + factoryNames[factoryNames.length -1];
			} else {
				return factoryNames.slice(0, maxLen - 1).join(', ') + ', and ' + (factoryNames.length - (maxLen - 1)) + ' others';
			}	
		}

		function getViewValues() {
			return viewValues;
		}

		function updateAllOrNone(list) {
			var allSelectedTemp = true;
			var noneSelectedTemp = true;
			viewValues.numberSelected = 0;
			angular.forEach(list, function(item) {
				if (item.selected) {
					viewValues.numberSelected += 1;
					noneSelectedTemp = false;
				} else if (!item.selected) {
					allSelectedTemp = false;
				}
			});

			viewValues.allSelected = allSelectedTemp;
			viewValues.noneSelected = noneSelectedTemp;
		}

		function updateVisibleAllOrNone(list) {
			var allSelectedTemp = true;
			var noneSelectedTemp = true;
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].selected) {
					noneSelectedTemp = false;
					break;
				}
			}
			for (i = 0; i < list.length; i++) {
				if (!list[i].selected) {
					allSelectedTemp = false;
					break;
				}
			}

			viewValues.allVisibleSelected = allSelectedTemp;
			viewValues.noneVisibleSelected = noneSelectedTemp;
		}

		function toggleAll(searchString) {
			var selVal = false;
			if (allVisibleSelected(searchString) || !noneVisibleSelected(searchString)) {
				viewValues.noneSelected = true;
				viewValues.allSelected = false;
				selVal = false;
			} else {
				viewValues.noneSelected = false;
				viewValues.allSelected = true;
				selVal = true;
			}

			var searchedMenu = getFilteredModel(tempFilterList, searchString);
			viewValues.numberSelected = 0;
			angular.forEach(searchedMenu, function(ig) {
				ig.selected = selVal;
			});

			angular.forEach(tempFilterList, function(it) {
				if (it.selected) {
					viewValues.numberSelected += 1;
				}
			});
		}

		function allVisibleSelected(searchString) {
			if (viewValues.visibleMenu) {
				var searchedMenu = getFilteredModel(tempFilterList, searchString);
				var numberVisible = searchedMenu.length;
				var selectedCount = 0;
				angular.forEach(searchedMenu, function(mi) {
					if (mi.selected) {
						selectedCount++;
					}
				});
				return selectedCount === numberVisible;
			}
			return false;
		}

		function noneVisibleSelected(searchString) {
			if (viewValues.visibleMenu) {
				var searchedMenu = getFilteredModel(tempFilterList, searchString);
				for (var i = 0; i < searchedMenu.length; i++) {
					if (searchedMenu[i].selected) {
						return false;
					}
				}
				return true;
			}
			return false;
		}

		function applySelection() {
			tempFilterList.forEach(function (factory, index) {
				filterList[index].selected = factory.selected;
			});
			if (viewValues.noneSelected) {
				filterList.forEach(function (factory, index) {
					factory.selected = true;
					tempFilterList[index].selected = true;
				});
				viewValues.noneSelected = false;
				viewValues.allSelected = true;
				viewValues.numberSelected = filterList.length;
			}
			viewValues.filterButtonText = getFactoryListString(3);
			setOpen(false);
		}

		function cancelSelection() {
			filterList.forEach(function (factory, index) {
				tempFilterList[index].selected = factory.selected;
			});
			updateAllOrNone(tempFilterList);
			setOpen(false);
		}

		function toggleItem(item, searchString, singleSelect) {
			angular.forEach(tempFilterList, function (it) {
				if (it.name === item.name){
					it.selected = !it.selected;
				}
			});
			updateAllOrNone(tempFilterList);
		}

		function getFilteredModel(fullModel, searchString) {
			var searchObject = {};
			searchObject.name = searchString;

			return $filter('filter')(fullModel, searchObject);
		}

		function isReadOnly() {
			return false;
		}
	}
})();
